import React from 'react';
import { Lock, ShieldCheck, Trash2, RefreshCcw } from 'lucide-react';

const CARDS = [
  { Icon: Lock,        title: 'No login' },
  { Icon: ShieldCheck, title: 'No saved library' },
  { Icon: Trash2,      title: 'Clear session anytime' },
  { Icon: RefreshCcw,  title: 'New upload resets' },
];

export default function PrivacyStrip() {
  return (
    <section id="privacy" data-testid="privacy-strip" className="py-12 sm:py-16">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="aurora-panel p-6 sm:p-10 relative reveal overflow-hidden">
          {/* Ambient glow */}
          <div
            className="absolute -top-32 -right-32 h-96 w-96 rounded-full pointer-events-none"
            style={{ background: 'radial-gradient(circle, rgba(126,224,109,0.20), transparent 65%)', filter: 'blur(40px)' }}
          />
          <div className="grid lg:grid-cols-[40%_60%] gap-8 items-center relative">
            <div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-3">— SESSION-BASED · PRIVATE BY DESIGN</div>
              <h2 className="font-display font-bold text-3xl sm:text-4xl leading-tight">
                Your session stays <span className="text-grad">yours.</span>
              </h2>
              <p className="text-white/60 mt-4 leading-relaxed max-w-md">
                SIMNOPSIS runs as a session-based prototype. No account is required, and nothing is saved after clearing or starting a new run.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              {CARDS.map(({ Icon, title }, i) => (
                <div key={i} className="glass-panel-soft p-4 flex items-start gap-3">
                  <div
                    className="h-10 w-10 rounded-lg flex items-center justify-center shrink-0"
                    style={{ background: 'rgba(126,224,109,0.08)', border: '1px solid rgba(126,224,109,0.18)' }}
                  >
                    <Icon className="h-4 w-4 text-[#7EE06D]" />
                  </div>
                  <div className="pt-0.5">
                    <div className="text-sm font-medium text-white">{title}</div>
                    <div className="font-mono text-[10px] tracking-widest uppercase text-[#7EE06D]/70 mt-0.5">ENFORCED</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
